import { composeValidators } from '@/utils/libs/react-final-form/validate';
import { isRequired, strMax } from '@/utils/validate/conditions';
/** 条件相談メッセージのバリデーション */
export const rfpNegotiateMessageValidation = {
    /** メッセージ内容 */
    description: composeValidators(isRequired, strMax(5000, '条件相談メッセージは5000文字以内で入力してください')),
};
